import { defaultSearchOptions } from './options';
import { getEffectiveOptionKeys } from '@/components/search/searchOptionKeys';
import { isNil, pick } from 'lodash-es';
const constructQuery = ({ searchOptions, pageOptions, structureFromKetcher, filterState, }) => {
    if (!searchOptions || !pageOptions || !filterState)
        return null;
    const searchType = searchOptions?.searchType;
    if (!searchType)
        return null;
    const getQueryValue = () => {
        if (searchType === 'FORMULA') {
            if (!structureFromKetcher)
                return searchOptions.formula;
        }
        return structureFromKetcher;
    };
    const getSearchType = () => {
        if (structureFromKetcher) {
            if (searchType === 'FORMULA' || searchType === 'MASS')
                return 'ADVANCED';
        }
        return searchType;
    };
    const getFilterValue = (id, options) => {
        const wasFilterSetInSearchOptions = options.features && options.features.includes(id) ? true : null;
        // if (wasFilterSetInSearchOptions) return true
        const filterInSearchResultOptions = filterState.find((f) => f.value === id);
        if (isNil(filterInSearchResultOptions?.state))
            return wasFilterSetInSearchOptions ? true : null;
        return filterInSearchResultOptions.state;
    };
    const effectiveOptionKeys = getEffectiveOptionKeys(searchOptions);
    const selectedOptions = pick(searchOptions, effectiveOptionKeys);
    const mergedSearchOptions = Object.assign({}, defaultSearchOptions, { minSimilarity: 0 }, selectedOptions);
    return {
        searchType: getSearchType(),
        inputType: 'MOL',
        query: getQueryValue(),
        offset: (pageOptions.currentPage - 1) * pageOptions.pageSize,
        limit: pageOptions.pageSize,
        minNumber: mergedSearchOptions.minNumOfStructures,
        maxNumber: mergedSearchOptions.maxNumOfStructures,
        hazardNames: mergedSearchOptions.hazardNames,
        sortBy: pageOptions.sortBy,
        sortDirection: pageOptions.sortDirection,
        params: {
            'min-similarity': mergedSearchOptions.minSimilarity,
            'max-similarity': 1,
            'fingerprint-type': mergedSearchOptions.fpType,
            'similarity-type': mergedSearchOptions.similarityType,
            'mass-type': mergedSearchOptions.massType,
            'min-mass': mergedSearchOptions.minMass,
            'max-mass': mergedSearchOptions.maxMass,
            'single-component': mergedSearchOptions.singleComponent,
            'formula': mergedSearchOptions.formula,
            'formula-query': mergedSearchOptions.queryFormula,
            'filter-stereo': getFilterValue('filter-stereo', mergedSearchOptions),
            'filter-chiral': getFilterValue('filter-chiral', mergedSearchOptions),
            'filter-isotopes': getFilterValue('filter-isotopes', mergedSearchOptions),
            'filter-charged': getFilterValue('filter-charged', mergedSearchOptions),
            'filter-multicomponent': getFilterValue('filter-multicomponent', mergedSearchOptions),
            'filter-radicals': getFilterValue('filter-radicals', mergedSearchOptions),
            'filter-salts': getFilterValue('filter-salts', mergedSearchOptions),
            'filter-polymers': getFilterValue('filter-polymers', mergedSearchOptions),
            'filter-sgroups': getFilterValue('filter-sgroups', mergedSearchOptions),
            'filter-toxicity': getFilterValue('filter-toxicity', mergedSearchOptions),
            'include-elements': mergedSearchOptions.includeElements,
            'exclude-elements': mergedSearchOptions.excludeElements,
            'hazard-source': mergedSearchOptions.hazardSource,
            'hazard-route': mergedSearchOptions.hazardRoute,
            'hazard-category': mergedSearchOptions.hazardCategory,
            'hazard-code': mergedSearchOptions.hazardCode,
            'hazard-organism': mergedSearchOptions.hazardOrganism,
            'min-toxicity': mergedSearchOptions.toxicity,
            'min-authority': mergedSearchOptions.authority,
            'export-all-props': true,
        },
    };
};
export { constructQuery };
